import request from 'utils/request';

const PREFIX = '/api/adv-receipt-entity-report/';

export const AdvBillingEntityAPI = {
  LIST: PREFIX + 'list',
};

export function getAdvReceiptEntityReport(data) {
  return request({
    url: AdvBillingEntityAPI.LIST,
    method: 'post',
    data,
  });
}
